import Tag from './tag';
import TagGroup from './tagGroup';
Tag.Group = TagGroup;
export default Tag;


